module.exports = __webpack_public_path__ + "static/media/1012863.5442a63a.png";